module.exports = __webpack_public_path__ + "assets/4da134a0823c430513c9474fe9413dee.png";